import { render, staticRenderFns } from "./OpeningCards.vue?vue&type=template&id=1c06c76f&"
import script from "./OpeningCards.vue?vue&type=script&lang=js&"
export * from "./OpeningCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports